import * as en from './meta'
import * as sv from './meta-sv'
import * as de from './meta-de'
import * as fa from './meta-fa'
import * as ar from './meta-ar'

export type Language = 'en' | 'sv' | 'de' | 'fa' | 'ar'

const lang = (localStorage.getItem('language') || 'en') as Language
const modules = { en, sv, de, fa, ar }
const active = (modules[lang] || en) as typeof en

export const {
    API_BASE_URL,
    ROLE_MAP,
    HeaderMeta,
    FooterMeta,
    TermsAndConditionsMeta,
    AdminHubMeta,
    AdminSettingsMeta,
    HomeMeta,
    EventsMeta,
    VolunteersMeta,
    DutyMeta,
    LoadingSpinnerMeta,
    LoginMeta,
    EventCardMeta,
    VolunteerCardMeta,
    DutyCardMeta,
    PreferenceMeta,
    PreferenceCardMeta,
    EventDetailMeta,
    EventFormModalMeta,
    DuplicateEventModalMeta,
    VolunteerFormModalMeta,
    DutyFormModalMeta,
    PreferenceFormModalMeta,
    DeleteDutyMeta,
    DeletePreferenceMeta,
    FlagMeta,
    CoreTeamMeta,
    CoreTeamStatsMeta,
    CoreTeamTableMeta,
    RejectedCoreTeamTableMeta,
    CoreTeamFormModalMeta,
    CoreTeamAddModalMeta,
    FlagCardMeta,
    FlagFormModalMeta,
    UpdateFlagFormMeta,
    DeleteFlagMeta,
    FlagCategoryFormModalMeta,
    UpdateFlagCategoryFormMeta,
    DeleteFlagCategoryMeta,
    ConfirmationModalMeta,
    DeleteEventMeta,
    UpdateEventFormMeta,
    UpdateDutyFormMeta,
    UpdatePreferenceFormMeta,
    AreaFormModalMeta,
    UpdateAreaFormMeta,
    DeleteAreaMeta,
    ShiftFormModalMeta,
    UpdateShiftFormMeta,
    CopyShiftAllocationsModalMeta,
    DuplicateAreaModalMeta,
    DuplicateShiftModalMeta,
    DeleteShiftMeta,
    TrainingListMeta,
    AdminTrainingsMeta,
    TrainingFormModalMeta,
    UpdateTrainingFormMeta,
    DocumentViewerMeta,
    VideoPlayerMeta,
    UnsupportedModuleViewerMeta,
    TrainingModulePageMeta,
    TrainingModuleMeta,
    VolunteerTrainingPageMeta,
    VolunteerPoliciesMeta,
    VolunteerTrainingPageDetailsMeta,
    ModuleCompletionModalMeta,
    ProfileMeta,
    VolunteerTableMeta,
    VolunteerTrainingTableMeta,
    VolunteerAllocationTableMeta,
    ConflictInformationTableMeta,
    VolunteerAllocationViewTableMeta,
    VolunteerEventShiftViewTableMeta,
    VolunteerAreaShiftViewTableMeta,
    LeadAssginmentViewTableMeta,
    MIVolunteerViewMeta,
    AssignTrainingFormModalMeta,
    AnnouncementMeta,
    AnnouncementsFormModalMeta,
    AnnouncementViewModalMeta,
    BulkTrainingAssignmentFormMeta,
    ShiftAssignmentFormMeta,
    AllLanguages,
    IVPositions,
    IVPositionFilterOptions,
    GenderOptions,
    UserMetaProps,
    UserFormModalMeta,
    UpdateUserFormMeta,
    DeleteUserMeta,
    DEFAULT_FILTERS,
    LeadAssignModalMeta,
    AccessColorMeta,
    AccessColorFormModalMeta,
    COLOR_PRESETS,
    AVAILABILITY_OPTIONS,
    VOLUNTEER_FOR_VISIT_MAP,
    VOLUNTEER_FOR_VISIT_MAP_INVERSE,
    TrainingSequenceEditMeta,
    VolunteerOverviewMeta,
    TrainingsOverviewMeta,
    AllocationsOverviewMeta,
    CoreStreamOverviewMeta,
    VolunteerStatsTableOverviewMeta,
    DidarAcknowledgementOverviewMeta,
    DashboardMeta,
    MangementAnalyticsMeta,
    CHART_COLORS,
    CHART_HEIGHT_MAP,
    CHART_WIDTH_CLASSES,
    ANALYTICS_TABS,
    InternationalRegisterationsMeta,
    ShiftStatusMap,
    EmailCampaignsMeta,
    EmailCampaignFormMeta,
    EmailCampaignPreviewMeta,
    ShiftMoveModalMeta,
    VolunteerUploadDocumentFormMeta,
    UPLOAD_DOCUMENT_TYPES,
    AllocationStatusPageMeta,
    ALLOCATION_STATUS_OPTIONS,
    CheckInPageMeta,
    DutyStatusOverviewMeta,
    QuickAllocateModalMeta,
    LiveOperationsMeta,
    LIVE_OPERATIONS_TABS,
    LoginFormMeta,
    ForgetPasswordMeta,
    ResetPasswordMeta,
    SignupMeta,
    VerifyEmailMeta,
    HouseholdSelectionMeta,
    CheckInLoginFormMeta,
    PublicFormsMeta,
    PublicFormFillMeta,
    GuidelineFormModalMeta,
    AdminGuidelinesMeta,
    VolunteerGuidelinesMeta,
    GuidelineDetailsMeta
} = active

export const EU_EVENT_IDS: number[] = [64, 63, 62, 60, 76]
export const UK_EVENT_IDS: number[] = [6, 34, 36, 40, 42, 44, 45, 46, 48, 49, 50, 51, 52, 54, 55]

export const ALLOCATED_DEFAULT_FILTERS = {
    ...DEFAULT_FILTERS,
    country: "both",
    profile_submitted: null,
    eligible_for_duty: null,
    age_start: null,
    age_end: null,
    volunteer_for_visit: null,
}
